
export default {
  name:"footerNav",
  data() {
    return {
      logo: require('@/static/images/headerLogo.png'),
    }
  },
}
